import { useEffect, useMemo } from 'react';

export function useProfilesGa() {
    const dimension = useMemo(() => `dimension${window.__nautilus_profiles?.env === 'production' ? '122' : '17'}`, []);
    useEffect(() => {
        ga('set', dimension, 'profiles');
    }, []);
}
